import { render, staticRenderFns } from "./TokevaTable.vue?vue&type=template&id=814d08d4&scoped=true"
import script from "./TokevaTable.vue?vue&type=script&lang=js"
export * from "./TokevaTable.vue?vue&type=script&lang=js"
import style0 from "./TokevaTable.vue?vue&type=style&index=0&id=814d08d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814d08d4",
  null
  
)

export default component.exports